import { render, staticRenderFns } from "./BorrowingReservations.vue?vue&type=template&id=31bfd492&"
import script from "./BorrowingReservations.vue?vue&type=script&lang=js&"
export * from "./BorrowingReservations.vue?vue&type=script&lang=js&"
import style0 from "./BorrowingReservations.vue?vue&type=style&index=0&id=31bfd492&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports